import { AppCard } from "@/components/ui";
import { CheckCircle2 } from "lucide-react";

type TStrengthsCardProps = {
  strengths?: string[] | null;
};

export function StrengthsCard({ strengths }: TStrengthsCardProps) {
  if (!strengths || strengths.length === 0) {
    return null;
  }

  return (
    <AppCard className="p-6">
      <div className="mb-4 flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100">
          <CheckCircle2 className="h-5 w-5 text-green-600" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Strengths</h3>
      </div>
      <ul className="space-y-4">
        {strengths.map((strength, index) => (
          <li
            key={index}
            className="flex items-start gap-4"
          >
            <div className="mt-0.5 flex-shrink-0">
              <CheckCircle2 className="h-5 w-5 text-green-600" />
            </div>
            <p className="text-sm leading-relaxed text-foreground">{strength}</p>
          </li>
        ))}
      </ul>
    </AppCard>
  );
}
